import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

// Generate a daily-rotated visitor fingerprint client-side. This is cookie-less
// and rotates every 24h — privacy-friendly and GDPR-safe (no persistent ID).
const getVisitorId = () => {
  const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
  const key = `aplj_vid_${today}`;
  let id = sessionStorage.getItem(key);
  if (!id) {
    id = Math.random().toString(36).slice(2, 12);
    sessionStorage.setItem(key, id);
  }
  return id;
};

const AnalyticsTracker = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return; // never track admin
    axios.post(`${API}/api/track`, {
      path: location.pathname,
      referrer: document.referrer || "",
      user_agent: navigator.userAgent,
      visitor_id: getVisitorId(),
    }).catch(() => {}); // fire-and-forget; failures are silent
  }, [location.pathname]);
  return null;
};

export default AnalyticsTracker;
